export default "__VITE_ASSET__Blb0kfxM__"